const AloneHeader = ({
  isIndicateur = false,
  isVolet,
}: {
  isIndicateur?: boolean;
  isVolet: boolean;
}) => {
  return (
    <div className="flex flex-col">
      {isIndicateur && (
        <div className="flex w-[1460px] border-b-2 h-[max-content] font-bold bg-[#f3f6f8] text-[14px] capitalizeh-[max-content]">
          <div className="w-[410px] h-[50px] border-r-2 text-center flex items-center justify-center">
            {isVolet
              ? 'Correspondance de cet indicateur Volet dans le Programme'
              : 'Correspondance de cet indicateur Programme dans les volets '}
          </div>
          <div className="w-[1050px] h-[50px] flex items-center justify-center">
            Complément info. indicateur
          </div>
        </div>
      )}

      <div
        className="flex  h-[50px]  font-bold bg-[#f3f6f8]   text-[14px] capitalizeh-[max-content]"
        style={{
          width: isIndicateur ? '1460px' : '100%',
        }}
      >
        {isIndicateur && (
          <>
            {
              <div className="w-[80px]  h-ful border-r-2 flex items-center justify-center text-[14px] capitalize">
                {' '}
                Volet
              </div>
            }
            <div className="w-[80px] pl-2  capitalize-first border-r-2 h-full flex items-center justify-center text-[14px]   capitalize">
              {' '}
              {isVolet ? '  N°indic. PROG' : '  N°indic. VOLET'}
            </div>
            <div
              style={{
                width: isIndicateur ? (isVolet ? '250px' : '250px') : '250px',
              }}
              className="flex-col pl-[2px] h-full border-r-2 capitalize-first flex items-center  justify-center text-[14px] capitalize"
            >
              {isVolet ? 'Intitulé indicateur Programme' : 'Intitulé Indicateur VOLET'}
            </div>
            <div className="w-[800px]  flex-col border-r-2 pl-[2px] h-full flex text-[#0099F2]  capitalize-first  items-center justify-center text-[14px] capitalize">
              Contribution à SNTE{' '}
            </div>
            <div className="w-[250px]  flex-col pl-[2px] h-full text-center capitalize-first  flex items-center justify-center text-[14px] capitalize">
              {isVolet
                ? " Source de vérification de l'indicateur VOLET"
                : "Source de vérification de l'indicateur PROGRAMME"}
            </div>
          </>
        )}
        {!isIndicateur && (
          <div className="w-full  px-[5px] h-full capitalize-first  flex items-center justify-center text-lg capitalize two-line-truncate">
            Intitulé contractuel du cadre logique
          </div>
        )}
      </div>
    </div>
  );
};

export default AloneHeader;
